var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.icon())?_c('img',{attrs:{"src":_vm.icon(),"alt":"","height":"50","width":"50"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }